import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
export const useVoucherState = () => {
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useDomainsAccount({}),
    data = _DomainsApiClient$hoo.data,
    isLoading = _DomainsApiClient$hoo.isLoading;
  const voucherState = !(data != null && data.isPremiumSite) ? 'free-plan' : data.hasValidVouchers ? 'premium-with-voucher' : 'premium-without-voucher';
  return {
    voucherState,
    isLoading,
    voucherSupportedTlds: data == null ? void 0 : data.voucherSupportedTlds
  };
};
//# sourceMappingURL=voucherState.js.map